exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable {\n    -webkit-transition: all .2s ease-in;\n    transition: all .2s ease-in;\n}\n\n.clickable:hover {\n    background: rgb(2, 117, 216);\n    color: #fff;\n    border-radius: .25em;\n    padding: 3px;\n}\n\nli.pl-zoneselection {\n    list-style-type: decimal;\n}\n\n.pl-generator-input-line label {\n    min-width: 100px;\n    display: inline-block;\n}\n\n.pl-hint {\n    background: rgb(250,250,110);\n    border-radius: .25em;\n    text-align: center;\n    padding: 10 px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location-generator/location-generator.component.css
// module id = ../../../../../src/app/location-generator/location-generator.component.css
// module chunks = main